// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BaseStrengthLinks_wrap__0Vhia","pill":"BaseStrengthLinks_pill__KV_R9","primary":"BaseStrengthLinks_primary__FjTzd","arrow":"BaseStrengthLinks_arrow___egHi"};